/* eslint-disable */

export enum ExternalSystem {
  /** SQUARE_CASH_PAYMENT - This transaction was created to fulfill a Cash App payment. */
  SQUARE_CASH_PAYMENT = "SQUARE_CASH_PAYMENT",
  /** SQUARE_CASH_TRANSFER - This transaction was created to fulfill a Cash App transfer (cash in or cash out). */
  SQUARE_CASH_TRANSFER = "SQUARE_CASH_TRANSFER",
  /**
   * BANKSY_TRANSFER - This transaction was created to fulfill a transfer between balances for the pilot program.
   *
   * @deprecated
   */
  BANKSY_TRANSFER = "BANKSY_TRANSFER",
  /**
   * DASH_CARD - This transaction was created via debit card pilot program.
   *
   * @deprecated
   */
  DASH_CARD = "DASH_CARD",
  /** CORE_PRO_ACH - This transaction was created via ACH using the CorePro platform. */
  CORE_PRO_ACH = "CORE_PRO_ACH",
  /** SHAZAM_CARD - This was a card transaction originating from Shazam's Issuer Processing system. */
  SHAZAM_CARD = "SHAZAM_CARD",
  /** MARQETA_CARD - This was a card transaction originating from Marqeta's prepaid system. */
  MARQETA_CARD = "MARQETA_CARD",
  /**
   * SQUARE_CASH_CLAWBACK - This transaction was created in response to a payment or transfer chargeback,
   * in order to make Square whole.
   */
  SQUARE_CASH_CLAWBACK = "SQUARE_CASH_CLAWBACK",
  /** GREEN_DOT_ACH - This transaction originated via ACH from GreenDot. */
  GREEN_DOT_ACH = "GREEN_DOT_ACH",
  /** CARD_FULFILLMENT - This event was created to update card fulfillment status. */
  CARD_FULFILLMENT = "CARD_FULFILLMENT",
  /**
   * CARD_MAILING - This event was created to update card mailing status
   *
   * @deprecated
   */
  CARD_MAILING = "CARD_MAILING",
  PITNEY_BOWES_CARD_MAILING = "PITNEY_BOWES_CARD_MAILING",
  /**
   * BITCOIN_BLOCKCHAIN - This transaction was created to fulfill a bitcoin transfer from or to an external bitcoin
   * wallet, hitting the blockchain.
   */
  BITCOIN_BLOCKCHAIN = "BITCOIN_BLOCKCHAIN",
  /** TRADEBLOCK - This event is a message to TradeBlock for initiating, settling or querying a trade. */
  TRADEBLOCK = "TRADEBLOCK",
  /** SQUARE_CASH_TRADING - This transaction was created as part of settling a bitcoin trade. */
  SQUARE_CASH_TRADING = "SQUARE_CASH_TRADING",
  /** THIRD_PARTY_TRADE - This transaction was created as part of an equity trade with Third Party. */
  THIRD_PARTY_TRADE = "THIRD_PARTY_TRADE",
  /** MARQETA_BUSINESS_CARD - This was a card transaction originating from Marqeta's Business prepaid system. */
  MARQETA_BUSINESS_CARD = "MARQETA_BUSINESS_CARD",
  /**
   * DRIVEWEALTH - This transaction was created as part of a securities transaction with DriveWealth.
   *
   * @deprecated
   */
  DRIVEWEALTH = "DRIVEWEALTH",
  /** INVEST_CORE - This transaction was created as part of a securities transaction with Invest Core. */
  INVEST_CORE = "INVEST_CORE",
  /** MARQETA_ACH - This was an ACH transaction on a Marqeta bank account. */
  MARQETA_ACH = "MARQETA_ACH",
  /** LEDGER_INTERNAL - This transaction was used for internal ledger accounting (ex: a customer merge). */
  LEDGER_INTERNAL = "LEDGER_INTERNAL",
  /** LOANSTAR - This transaction was created as part of a loan with Loanstar. */
  LOANSTAR = "LOANSTAR",
  /** SQUARE_CASH_REFUND - This transaction event was used for an internal refund. */
  SQUARE_CASH_REFUND = "SQUARE_CASH_REFUND",
  /** SQUARE_CASH_ADMIN - This transaction resulted from an action taken by a Cash Admin. */
  SQUARE_CASH_ADMIN = "SQUARE_CASH_ADMIN",
  /**
   * MOBILE_CHECK_DEPOSIT - This transaction is deprecated in favor of MITEK_CHECK_DEPOSIT since we want to be vendor specific
   *
   * @deprecated
   */
  MOBILE_CHECK_DEPOSIT = "MOBILE_CHECK_DEPOSIT",
  /** MITEK_CHECK_DEPOSIT - This transaction was created when user deposit a Mitek deposit check to Cash App. */
  MITEK_CHECK_DEPOSIT = "MITEK_CHECK_DEPOSIT",
  /** BTC_NETWORK - This transaction was created to fulfill a BTC P2P transfer * */
  BTC_NETWORK = "BTC_NETWORK",
  /** RISKARBITER_ACH - This transaction event was created as part of actioning a Riskarbiter ACH risk evaluation */
  RISKARBITER_ACH = "RISKARBITER_ACH",
  /** INVEST_CRYPTO - This transaction was created as part of a crypto-fiat transaction with Invest Crypto. */
  INVEST_CRYPTO = "INVEST_CRYPTO",
  /** VDBS - This transaction was created as a paper money deposit via VDBS with Papermate. */
  VDBS = "VDBS",
  /** PAY_WITH_CASH - This transaction was created as part of a Pay With Cash transaction. */
  PAY_WITH_CASH = "PAY_WITH_CASH",
  /** INSTANT_PAY - This transaction was created as part of an Instant Pay transaction. */
  INSTANT_PAY = "INSTANT_PAY",
  /** MODERN_TREASURY_WIRE - This was a WIRE transaction on a Modern Treasury bank account. */
  MODERN_TREASURY_WIRE = "MODERN_TREASURY_WIRE",
  /** VISA_CARD - This was a card transaction originating from VISA DEX. */
  VISA_CARD = "VISA_CARD",
  /** RISKARBITER_WIRE - This transaction event was created as part of actioning a Riskarbiter Wire risk evaluation */
  RISKARBITER_WIRE = "RISKARBITER_WIRE",
  /** CRYPTO_SPARKY - This transaction was created as part of a Lightning Withdrawal */
  CRYPTO_SPARKY = "CRYPTO_SPARKY",
  /** VISA_DPS_CARD - This was a card transaction originating from VISA DPS. */
  VISA_DPS_CARD = "VISA_DPS_CARD",
  /** NETWORK_OF_NETWORKS_GLOBAL_X - This transaction was created for transfers from Cash to local payment networks outside the Cash ecosystem * */
  NETWORK_OF_NETWORKS_GLOBAL_X = "NETWORK_OF_NETWORKS_GLOBAL_X",
  /** DISPUTRON - This transaction event was a result of a decision made via Disputron. */
  DISPUTRON = "DISPUTRON",
  /** CASH_LIMITS - This transaction was created as a result of a decision made by cash-limits */
  CASH_LIMITS = "CASH_LIMITS",
  /** CASH_ME_OUTSIDE - This transaction was created as part of an international remittance through cash-me-outside */
  CASH_ME_OUTSIDE = "CASH_ME_OUTSIDE",
  /** CASH_BARB - This transaction was created as a result of a decision made by barb */
  CASH_BARB = "CASH_BARB",
  /** ENSENTA_CHECK_DEPOSIT - This transaction was created when users deposit an Ensenta deposit check to Cash App */
  ENSENTA_CHECK_DEPOSIT = "ENSENTA_CHECK_DEPOSIT",
  /** SQUARE_BANKING_OPS - This transaction was a result of a decision made to a dispute via Square Banking Risk OPS. */
  SQUARE_BANKING_OPS = "SQUARE_BANKING_OPS",
  /** OVERDRAFT - This transaction was created to update the limit amount for the Overdraft balance. */
  OVERDRAFT = "OVERDRAFT",
  /** CASH_DDA_ACH - This was an ACH transaction on a cash-dda managed account (currently Choice). */
  CASH_DDA_ACH = "CASH_DDA_ACH",
  /** WELLS_FARGO_WIRE - This was a WIRE transaction on a Wells Fargo bank account. */
  WELLS_FARGO_WIRE = "WELLS_FARGO_WIRE",
  /** CASH_FOR_BUSINESS - This is a Cash for Business non-P2P transaction, such as Tap to Pay. */
  CASH_FOR_BUSINESS = "CASH_FOR_BUSINESS",
}
